export default __webpack_public_path__ + "static/media/delete_red.0ede6de9.svg";